import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-failure",
  "use": "icon-failure-usage",
  "viewBox": "0 0 11 11",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 11 11\" id=\"icon-failure\"><circle cx=\"5.895\" cy=\"5.462\" r=\"4.5\" stroke=\"#EF454A\" /><path stroke=\"#EF454A\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.31 4.163 4.696 6.778M7.31 6.778 4.696 4.163\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol